// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"7a1dfe06","126":"d6c9a115","144":"2aa96cda","307":"6220bfb4","534":"0bc0c088","679":"7e1b6c7f","854":"d6e927c5","999":"9a4c5d22"}[chunkId] + ".chunk.js";
};